import { AsyncMigrationJobApi } from "@/api";

export async function getAll() {
  const { data } = await AsyncMigrationJobApi.getAll();
  return data;
}
